import React, { Suspense, useState, useEffect, useMemo } from 'react'
import { Button, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import { useGetAccountsQuery } from '../../../../api/recalc/endpoints/accountsApiSlice';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useNavigate, useLocation } from 'react-router-dom';
import EnergyXplorerDrawerContainer from './EnergyXplorerDrawerContainer';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../redux/snackbarSlice';
import { getSelectedAccount } from '../../../../redux/selectedAccountSlice';
import { useGetEnergyGroupsByUserQuery } from '../../../../api/recalcV2/endpoints/energyGroupsApiSlice';


//   Import some federated module here

const EnergyXplorerDatagrid = React.lazy(() =>
  import('remote/EnergyXplorerDatagrid').catch(() => ({
    default: () => <div>Failed to load</div>,
  }))
);

const EnergyXplorerManagementPage = () => {

  const [selectedRow, setSelectedRow] = useState({});
  const selectedAccount = useSelector(getSelectedAccount);



  const { data: accounts, isLoading, isSuccess: isSuccessAccounts, isError: isErrorAccounts, error: errorAccounts, isFetching } = useGetAccountsQuery()
  const { data: energyGroups } = useGetEnergyGroupsByUserQuery()


  useEffect(() => {
    if (!selectedRow?.Name) return;

    setSelectedRow(accounts?.find(account => account.Name === selectedRow?.Name))

  }, [accounts])

  const rows = useMemo(() => {
    let result = energyGroups ?? []
    if (accounts === undefined || accounts?.length === 0) return []

    result = result.map(g => {
      let a = accounts.find(a => g.accountId === a.AccountId)

      const initiativesCount = g.energyInitiatives.reduce((acc, i) => {
        return acc + 1
      }, 0)

      const nodeCount = g.energyTreeNodes.reduce((acc, i) => {
        return acc + 1
      }, 0)

      return ({AccountId: a.AccountId, Name: a.Name, hasService: a.Services.length !== 0 && a.Services.some(s => s.Name === 'EnergyXplorer'), ...g, nodeCount, initiativesCount, id: g.energyGroupId})
    })
    return result
  }, [accounts, energyGroups])

  const stats = useMemo(() => {
    if (energyGroups === undefined || energyGroups?.length === 0) return []

    const totalNodes = energyGroups.reduce((acc, g) => {
      return acc + g.energyTreeNodes.length
    }, 0)

    const totalInitiatives = energyGroups.reduce((acc, g) => {
      return acc + g.energyInitiatives.length
    }, 0)

    const totalEnergyGroups = energyGroups.length

    const totalAccounts = new Set(energyGroups.map(g => g.accountId)).size;
    return ([
      {name: '# Noder', value: totalNodes},
      {name: '# Initiatives', value: totalInitiatives},
      {name: '# Energy groups', value: totalEnergyGroups},
      {name: '# Accounts', value: totalAccounts},
      ])
  }, energyGroups) 

  return (
    <Container maxWidth='xxl'>
      <Suspense fallback={
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', verticalAlign: 'center' }}>
          <CircularProgress />
        </Box>}>
        <Box sx={{ display: 'flex', height: '70vh', width: '100%' }}>
          <Grid container spacing={2}>

          {stats.map(s => <Grid item lg={3}>
            <ServiceCard {...s} />
          </Grid>)}
          <Grid item lg={12} maxHeight={'80vh'}>
          <EnergyXplorerDatagrid initialRows={rows} isLoading={isFetching} setSelectedRow={setSelectedRow} account={selectedAccount} />
        </Grid>
        </Grid>
        </Box>
        </Suspense>
      <EnergyXplorerDrawerContainer isOpen={selectedRow?.Name} onClose={() => setSelectedRow({})} account={selectedRow} />
    </Container>
  )
}

export default EnergyXplorerManagementPage

const ServiceCard = (props) => {
  const { name, value } = props
  
  return (
    <Card variant='outlined'>


        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: 2 }}>
            <Typography variant="body1" color="textSecondary" fontWeight="bold">
              {name}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography variant="h4" color="textPrimary" fontWeight={'bold'}>
                {value}
              </Typography>
            </Box>
          </Box>
        </CardContent>
    </Card>
  )

}